import React from 'react'
import './AdditionalSectorsWidget.scss'

const AdditionalSectorsWidget = () => {
  const additionalSectors = [
    'Automotive',
    'Aviation',
    'Construction',
    'Energy and Utilities',
    'FMCG',
    'Food and Beverage',
    'Hospitality and Travel',
    'Logistics',
    'Media and Entertainment',
    'Real estate',
  ];

  return (
    <section className='additional-sectors'>
      <h3>Other Sectors We Serve</h3>
      <ul>
        {additionalSectors.map((sector, index) => (
          <li key={index}>{sector}</li>
        ))}
      </ul>
    </section>
  );
};

export default AdditionalSectorsWidget